module.exports = __webpack_public_path__ + "img/icon1.4b3f10bd.svg";